import type { DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

export const DarkTalosTheme: DefaultTheme = mapDarkTheme(darkColors, {
  name: 'DarkDefault',
});
